import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  Breadcrumbs,
  Link,
  Box,
  Alert,
  Snackbar,
} from '@mui/material';
import { NavigateNext } from '@mui/icons-material';
import AcademicQuestionPaperForm from './AcademicQuestionPaperForm';
import { academicQuestionPaperApi } from './academicQuestionPaperApi';

const AddQuestionPaper = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (data) => {
    setLoading(true);
    setError(null);
    console.log(data);
    
    try {
      await academicQuestionPaperApi.create(data);
      setSuccess(true);
      setTimeout(() => {
        navigate('/question-papers');
      }, 1500);
    } catch (err) {
      const message = err.response?.data?.message || err.message || 'Failed to create question paper';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/question-papers');
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Breadcrumbs
        separator={<NavigateNext fontSize="small" />}
        aria-label="breadcrumb"
        sx={{ mb: 3 }}
      >
        <Link color="inherit" href="/">
          Home
        </Link>
        <Link color="inherit" href="/question-papers">
          Question Papers
        </Link>
        <Typography color="text.primary">Add New</Typography>
      </Breadcrumbs>

      <Typography variant="h5" gutterBottom>
        Create New Question Paper
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Fill in the details below to create a new academic question paper.
      </Typography>

      <AcademicQuestionPaperForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        loading={loading}
      />

      <Snackbar
        open={success}
        autoHideDuration={3000}
        onClose={() => setSuccess(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="success" onClose={() => setSuccess(false)}>
          Question paper created successfully!
        </Alert>
      </Snackbar>

      <Snackbar
        open={!!error}
        autoHideDuration={6000}
        onClose={() => setError(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="error" onClose={() => setError(null)}>
          {error}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default AddQuestionPaper;